module.exports = __webpack_public_path__ + "static/media/login_full_bg5.99cbb425.jpg";